import Vue from 'vue';
import { matchDetailApi } from '@/api/index';

const state = {
    matchDetailFormation: {}, // 比赛基本信息
    matchOverviewFormation: {}, // overview 模块数据
    matchAnalysisFormation: {}, // analysis 模块数据
    matchOddsFormation: { // odds模块数据
        euro: [],
        asia: [],
        overUnder: []
    }
};

const actions = {
    FETCH_MATCH_DETAIL_FORMATION: ({ commit, state }, { matchId }) => { // 请求获取比赛基本信息
        return matchDetailApi.fetchMatchDetailFormation(matchId).then(matchDetailFormation => commit('SET_MATCH_DETAIL_FORMATION', {
            matchId,
            matchDetailFormation
        })).catch(error => console.log(error));
    },
    FETCH_MATCH_OVERVIEW_FORMATION: ({ commit, state }, { matchId, locale }) => { // 请求获取 overview 模块信息
        return matchDetailApi.fetchMatchOverviewFormation(matchId, locale).then(matchOverviewFormation => commit('SET_MATCH_OVERVIEW_FORMATION', {
            matchId,
            matchOverviewFormation
        })).catch(error => console.log(error));
    },
    FETCH_MATCH_ANALYSIS_FORMATION: ({ commit, state }, { matchId, locale, isJSON }) => { // 请求获取 analysis 模块信息
        return matchDetailApi.fetchMatchAnalysisFormation(matchId, locale, isJSON).then(matchAnalysisFormation => commit('SET_MATCH_ANALYSIS_FORMATION', {
            matchId,
            matchAnalysisFormation
        })).catch(error => console.log(error));
    },
    FETCH_MATCH_ODDS_EURO: ({ commit, state }, { matchId }) => { // 请求获取odds模块 euro赔率信息
        return matchDetailApi.fetchMatchOddsEuro(matchId).then(euro => commit('SET_MATCH_ODDS_EURO', {
            matchId,
            euro
        })).catch(error => console.log(error));
    },
    FETCH_MATCH_ODDS_ASIA: ({ commit, state }, { matchId }) => { // 请求获取odds模块 asia赔率信息
        return matchDetailApi.fetchMatchOddsAsia(matchId).then(asia => commit('SET_MATCH_ODDS_ASIA', {
            matchId,
            asia
        })).catch(error => console.log(error));
    },
    FETCH_MATCH_ODDS_OVER_UNDER: ({ commit, state }, { matchId }) => { // 请求获取odds模块 over_under赔率信息
        return matchDetailApi.fetchMatchOddsOverUnder(matchId).then(overUnder => commit('SET_MATCH_ODDS_OVER_UNDER', {
            matchId,
            overUnder
        })).catch(error => console.log(error));
    }
};
const mutations = {
    SET_MATCH_DETAIL_FORMATION: (state, { matchId, matchDetailFormation }) => { // 设置比赛基本信息
        Vue.set(state, 'matchDetailFormation', matchDetailFormation, matchId || false);
    },
    SET_MATCH_OVERVIEW_FORMATION: (state, { matchId, matchOverviewFormation }) => { // 设置 overview 模块信息
        Vue.set(state, 'matchOverviewFormation', matchOverviewFormation, matchId || false);
    },
    SET_MATCH_ANALYSIS_FORMATION: (state, { matchId, matchAnalysisFormation }) => { // 设置  analysis 模块信息
        Vue.set(state, 'matchAnalysisFormation', matchAnalysisFormation, matchId || false);
    },
    SET_MATCH_ODDS_EURO: (state, { matchId, euro }) => { // 设置  odds模块 euro赔率信息
        Vue.set(state.matchOddsFormation, 'euro', euro);
    },
    SET_MATCH_ODDS_ASIA: (state, { matchId, asia }) => { // 设置  odds模块 asia赔率信息
        Vue.set(state.matchOddsFormation, 'asia', asia);
    },
    SET_MATCH_ODDS_OVER_UNDER: (state, { matchId, overUnder }) => { // 设置  odds模块 over_under赔率信息
        Vue.set(state.matchOddsFormation, 'overUnder', overUnder);
    }
};

export default {
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/matchDetailStore.js